"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNurseScheduleDto = instanceOfFacilityNurseScheduleDto;
exports.FacilityNurseScheduleDtoFromJSON = FacilityNurseScheduleDtoFromJSON;
exports.FacilityNurseScheduleDtoFromJSONTyped = FacilityNurseScheduleDtoFromJSONTyped;
exports.FacilityNurseScheduleDtoToJSON = FacilityNurseScheduleDtoToJSON;
exports.FacilityNurseScheduleDtoToJSONTyped = FacilityNurseScheduleDtoToJSONTyped;
const ScheduleAvailabilityDateDto_1 = require("./ScheduleAvailabilityDateDto");
const NurseOtherFacilityCommitmentDto_1 = require("./NurseOtherFacilityCommitmentDto");
const FacilityNurseShiftDto_1 = require("./FacilityNurseShiftDto");
/**
 * Check if a given object implements the FacilityNurseScheduleDto interface.
 */
function instanceOfFacilityNurseScheduleDto(value) {
    if (!('availableDates' in value) || value['availableDates'] === undefined)
        return false;
    if (!('facilityShifts' in value) || value['facilityShifts'] === undefined)
        return false;
    if (!('otherCommitments' in value) || value['otherCommitments'] === undefined)
        return false;
    return true;
}
function FacilityNurseScheduleDtoFromJSON(json) {
    return FacilityNurseScheduleDtoFromJSONTyped(json, false);
}
function FacilityNurseScheduleDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'availableDates': (json['availableDates'].map(ScheduleAvailabilityDateDto_1.ScheduleAvailabilityDateDtoFromJSON)),
        'facilityShifts': (json['facilityShifts'].map(FacilityNurseShiftDto_1.FacilityNurseShiftDtoFromJSON)),
        'otherCommitments': (json['otherCommitments'].map(NurseOtherFacilityCommitmentDto_1.NurseOtherFacilityCommitmentDtoFromJSON)),
    };
}
function FacilityNurseScheduleDtoToJSON(json) {
    return FacilityNurseScheduleDtoToJSONTyped(json, false);
}
function FacilityNurseScheduleDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'availableDates': (value['availableDates'].map(ScheduleAvailabilityDateDto_1.ScheduleAvailabilityDateDtoToJSON)),
        'facilityShifts': (value['facilityShifts'].map(FacilityNurseShiftDto_1.FacilityNurseShiftDtoToJSON)),
        'otherCommitments': (value['otherCommitments'].map(NurseOtherFacilityCommitmentDto_1.NurseOtherFacilityCommitmentDtoToJSON)),
    };
}
//# sourceMappingURL=FacilityNurseScheduleDto.js.map